// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"51546037","469":"1deb9b29","856":"845b3b74"}[chunkId] + ".js";
};